export default __webpack_public_path__ + "static/media/cientifica5.ba6ab2b7.jpg";